import React from 'react';
import { Slider } from '@payfit/midnight/dist/Slider';

import { useParams } from '../../utils/useParams';
import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { Box } from './Box';
import { PricingBannerProps, Banner } from './Banner';

export interface BoxSliderProps extends DefaultBsComponent {
  name: string;
  min: number;
  max: number;
  initialValue: number;
  banner?: PricingBannerProps;
  label: string;
}
export const BoxSlider = ({
  name,
  min = 1,
  max = 10,
  initialValue = 1,
  label = '',
  banner,
  children,
}: BoxSliderProps) => {
  const [params, setParams] = useParams();

  return (
    <Box className={classNames('flex flex-col gap-16')}>
      {children}
      <Slider
        label={label}
        value={+params?.[name] || initialValue}
        min={min}
        max={max}
        renderValue={(value) => {
          if (value === max) return `${value}+`;
          return `${value}`;
        }}
        onChange={(value: number) => {
          setParams(name, value.toString());
        }}
      />
      {banner && Banner(banner)}
    </Box>
  );
};
